import initialState from './initialState'

/**
 * Replaces current Data about sale
 * @param {*} state
 * @param {*} salePayLoad
 */
const SC = 'SC'
const SE = 'SE'
const SALE_TYPE_TICKET_ID = 1
const SALE_TYPE_INVOICE_ID = 2

const SET_ARRAY_PAYMENTS = (state, arrayPayments) =>
    (state.arrayPayments = arrayPayments)

const SET_SALE = function(state, salePayLoad) {
    console.log('SALE', salePayLoad)

    if (state.payer == SC) {
        console.log(salePayLoad.pos_detail_sales, 'salePayload')
        //state.saleDetail=(salePayLoad.pos_detail_sales) //saleDetail now its disabled.
        if (state.saleDetail === null) {
            state.saleDetail = salePayLoad.pos_detail_sales
        } else {
            state.saleDetail.push(...salePayLoad.pos_detail_sales)
        }
        state.customerId = salePayLoad.sl_customer_id
        if (state.posSaleType === null) {
            //only set once
            state.posSaleType = salePayLoad.pos_sale_type_id
        }
        state.total = salePayLoad.ticket_total
        state.totalInvoice = salePayLoad.invoice_total
        state.seller = salePayLoad.g_seller_user
    } else if (state.payer == SE) {
        state.saleDetail = salePayLoad.pos_detail_employee_sales
        state.customerId = salePayLoad.g_seller_user_id
        state.posSaleType = SALE_TYPE_TICKET_ID
        state.totalInvoice = salePayLoad.invoice_total
        state.saleEmployee = salePayLoad.g_employee_user
    }
    state.seller = salePayLoad.g_seller_user
    state.total = salePayLoad.ticket_total

    state.netTotal = salePayLoad.new_net_subtotal

    state.iva = salePayLoad.iva

    state.ticketCode = salePayLoad.id
    state.discountOrChargePercentage = salePayLoad.discount_or_charge_percentage
}

const SUBTRACT_SALE_MULTIPLE = function(state, salePayLoad) {
    if (state.payer == SC) {
        state.saleDetail = state.saleDetail.filter(
            r => r.pos_sale_id !== salePayLoad.id
        )
        console.log(state.saleDetail)
        //state.saleDetail.splice(state.saleDetail.indexOf(saleTicket), 1)
        //state.customerId = salePayLoad.sl_customer_id
        //state.posSaleType = salePayLoad.pos_sale_type_id
        state.total -= salePayLoad.ticket_total
        state.totalInvoice -= salePayLoad.invoice_total
        //state.seller = salePayLoad.g_seller_user
    } else if (state.payer == SE) {
        // state.saleDetail = salePayLoad.pos_detail_employee_sales
        // state.customerId = salePayLoad.g_seller_user_id
        // state.posSaleType = SALE_TYPE_TICKET_ID
        // state.total = salePayLoad.ticket_total
        // state.totalInvoice = salePayLoad.invoice_total
    }
    state.netTotal -= salePayLoad.new_net_subtotal
    state.iva -= salePayLoad.iva
    //state.ticketCode = salePayLoad.id
    //state.discountOrChargePercentage = salePayLoad.discount_or_charge_percentage
}

const RESET_SALE_AFTER_REMOVE_TICKET = function(state, newTotals) {
    if (state.payer == SC) {
        //state.saleDetail.splice(state.saleDetail.indexOf(saleTicket), 1)
        //state.customerId = salePayLoad.sl_customer_id
        //state.posSaleType = salePayLoad.pos_sale_type_id
        state.total = newTotals.total
        state.totalInvoice = newTotals.net_subtotal + newTotals.iva
        //state.seller = salePayLoad.g_seller_user
    } else if (state.payer == SE) {
        // state.saleDetail = salePayLoad.pos_detail_employee_sales
        // state.customerId = salePayLoad.g_seller_user_id
        // state.posSaleType = SALE_TYPE_TICKET_ID
        // state.total = salePayLoad.ticket_total
        // state.totalInvoice = salePayLoad.invoice_total
    }
    state.netTotal = newTotals.new_net_subtotal
    state.iva = newTotals.iva
}

/**
 *
 * @param {*} status
 * @param {*} id
 */
const SET_PAYMENT_METHOD = function(status, id) {
    status.paymentMethod = id
}

const SET_SALE_DETAILS = function(status, payload) {
    status.saleDetail = payload
}

/**
 * @description
 * Returns state to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

const SET_PAYMENT = function(state, paymentPayLoad) {
    state.payment = paymentPayLoad
}

const SET_PAYMENT_ARRAY = function(state, payload) {
    state.arrayPayment = payload
}

const SET_TICKET = function(state, ticketCodePayload) {
    state.ticketCode = ticketCodePayload
}

const SET_POS_SALE_TYPE = function(state, newid) {
    state.posSaleType = newid
}

const SET_PURCHASE_ORDER = function(state, oc) {
    state.oc = oc
}

const RESET = function(state) {
    Object.assign(state, initialState())
}

const SET_PAYMENT_DETAIL = function(state, plPaymentDetail) {
    state.paymentDetail = plPaymentDetail
}

const SAVE_PAYMENT = function(state) {
    if (state.paymentMethod === 1) {
        // If current payment is cash payment
        let posCashPayment = searchCashPayment(state) // First we ask if a cash payment has already made
        if (posCashPayment != -1) {
            // If a cash payment has been made, current payment is added
            let acum =
                parseInt(state.arrayPayments[posCashPayment].payment) +
                parseInt(state.payment)
            state.arrayPayments[posCashPayment].payment = acum.toString()
            state.lastPaymentMethod = state.paymentMethod // Last payment method is updated
            return
        }
    }
    // In any other case, current payment is pushed to arrayPayments

    // ;['accountNumber, plaza, serialNumber'].forEach(p => {
    //     if (state.paymentDetail[p])
    //         state.paymentDetail[p] = parseInt(state.paymentDetail[p])
    // })
    state.arrayPayments.push({
        payment: state.payment, // Amount of payment
        paymentMethod: state.paymentMethod,
        paymentDetail: state.paymentDetail,
    })
    state.lastPaymentMethod = state.paymentMethod // Last payment method is updated
}

const searchCashPayment = function(state) {
    var i
    for (i = 0; i < state.arrayPayments.length; i++) {
        if (state.arrayPayments[i].paymentMethod === 1) {
            // If cash payment is found, returns it's position in the array
            return i
        }
    }
    return -1
}

const CLEAR_PAYMENT = function(state) {
    state.payment = ''
    state.paymentDetail = null
}

const SET_PAYER = function(state, payer) {
    state.payer = payer
}

const SET_BANKS = function(state, banks) {
    state.banks.length = 0
    for (let i = 0; i < banks.data.length; i++) {
        state.banks.push(banks.data[i])
    }
}

const SET_INVOICE_OBSERVATION = function(state, observation) {
    state.invoiceObservation = observation
}
/*
 */
const ADD_MULTIPLE_SALE_TICKET = function(state, saleTicket) {
    state.multipleSaleTicket.push(saleTicket)
}

const DELETE_MULTIPLE_SALE_TICKET = function(state, saleTicket) {
    let tickets = state.multipleSaleTicket
    tickets.splice(state.multipleSaleTicket.indexOf(saleTicket), 1)
    state.multipleSaleTicket = tickets
}

const SET_IS_CHANGE_TICKET = function(state, val) {
    state.isChangeTicket = val
}

const SET_SWITCH_MULTIPLE_TICKET = function(state, val) {
    state.switchMultipleTicket = val
}

export default {
    SET_SALE,
    SET_TICKET,
    SET_PAYMENT,
    RESET_STATE,
    RESET,
    SET_PAYMENT_METHOD,
    SET_SALE_DETAILS,
    SET_POS_SALE_TYPE,
    SET_PAYMENT_DETAIL,
    SAVE_PAYMENT,
    CLEAR_PAYMENT,
    SET_PAYER,
    SET_PAYMENT_ARRAY,
    SET_BANKS,
    SET_PURCHASE_ORDER,
    SET_INVOICE_OBSERVATION,
    ADD_MULTIPLE_SALE_TICKET,
    SUBTRACT_SALE_MULTIPLE,
    DELETE_MULTIPLE_SALE_TICKET,
    RESET_SALE_AFTER_REMOVE_TICKET,
    SET_ARRAY_PAYMENTS,
    SET_IS_CHANGE_TICKET,
    SET_SWITCH_MULTIPLE_TICKET,
}
